<div class="bg-white mb15 pad15 border position-relative">

  <div class="ctm-tab custom-card card-accord">
    <ng-container
      *ngIf="(workOrderTimeStampSummary?.length > 0 || jobTimeStampSummary?.length > 0); else load_elsePart">
      <div class="mr-3 timerLable" *ngIf="totaltime?.length > 0">
        {{totalspenttime}} / {{totaltime}}
      </div>
      <ngb-accordion [closeOthers]="false" [activeIds]="activePanelIds">
        <ngb-panel id="static-1" *ngIf="isWorkorderTimer">

          <ng-template ngbPanelHeader class="custom-header ctm">
            <div class="d-flex align-items-center">
              <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center abc text-left"
                aria-label="Center Align">
                lblworkOrderTimeStampSummary
                <div class="ml-auto d-flex">
                  
                  <div>
                    <em class="fas fa-angle-down fa-lg i1"></em>
                    <em class="fas fa-angle-up fa-lg i2"></em>
                  </div>
                </div>
              </button>
            </div>
          </ng-template>
          <ng-template ngbPanelContent>
            <div class="table-responsive tableMx-15">
              <table class="tablest1">
                <thead class="head-pt-0">
                  <tr>
                    <th style="width:5%" scope="col">#</th>
                    <th style="width:15%" scope="col" translate>lblMechanicName</th>
                    <th style="width:15%" scope="col" translate>lblStartTime</th>
                    <th style="width:15%" scope="col" translate>lblEndTime</th>
                    <th style="width:15%" scope="col" translate>lblDuration</th>
                    <th style="width:20%" scope="col" translate>lblReason</th>
                    <th scope="col" translate>lblUpdatedBy</th>
                    <th scope="col" translate>lblUpdatedDate</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngIf="workOrderTimeStampSummary?.length>0; else load_else">
                    <tr *ngFor="let summary of workOrderTimeStampSummary; let i=index">
                      <td>{{i+1}}</td>
                      <td><span translate>{{summary.mechanicName}}</span></td>
                      <td><span translate> {{summary.startTime | date:'shortDate' }}
                          {{summary.startTime | date:'HH:mm:ss' }}</span></td>
                      <td><span translate> {{summary.endTime | date:'shortDate' }}
                          {{summary.endTime | date:'HH:mm:ss' }}</span></td>
                      <td>
                        <div *ngIf="summary.duration ==null">
                          <span translate>-</span>
                        </div>
                        <div *ngIf="summary.duration !=null">
                          <span translate>{{summary.duration}}</span>
                        </div>
                      </td>
                      <td>
                        <div *ngIf="summary.reason ==null">
                          <span translate>-</span>
                        </div>
                        <div *ngIf="summary.reason !=null">
                          <span translate>{{summary.reason}}</span>
                        </div>
                      </td>
                      <td><span translate>{{summary.updatedBy}}</span></td>
                      <td><span translate>{{summary.updatedDate | date:'short'}}</span></td>
                    </tr>
                  </ng-container>
                  <ng-template #load_else>
                    <tr>
                      <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                    </tr>
                  </ng-template>
                </tbody>
              </table>
            </div>
          </ng-template>
        </ngb-panel>
        <ngb-panel id="static-2">

          <ng-template ngbPanelHeader class="custom-header ctm">
            <div class="d-flex align-items-center">
              <button ngbPanelToggle translate class="btn d-flex w-100 align-items-center abc text-left"
                aria-label="Center Align">
                lbljobTimeStampSummary
                <div class="ml-auto">
                  <em class="fas fa-angle-down fa-lg i1"></em>
                  <em class="fas fa-angle-up fa-lg i2"></em>
                </div>
              </button>
            </div>
          </ng-template>
          <ng-template ngbPanelContent>
            <div class="table-responsive tableMx-15">
              <table class="tablest1">
                <thead class="head-pt-0">
                  <tr>
                    <th style="width:1%" scope="col"></th>
                    <th style="width:5%" scope="col">#</th>
                    <th style="width:15%" scope="col" translate>lblJobDescription</th>
                    <th scope="col" style="width: 15%;"><span translate>lblTotalTime</span><br><span class="text-sm1"
                        translate>lblHrs</span></th>
                    <th style="width:15%" scope="col" translate>lblStatus</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngIf="jobTimeStampSummary?.length>0; else load_else">
                    <ng-container *ngFor="let job of jobTimeStampSummary; let i=index" class="mb-3">
                      <tr [ngClass]="{'bg-info': job.expanded}" style="cursor: pointer;">
                        <td style="width:30px" class="pr-0" (click)="job.expanded = !job.expanded">
                          <a class="btn btn-ico" ngbTooltip="{{'lblShowStampinItem' | translate}}"
                            [placement]="tooltipPlacement" tooltipClass="custom-revert">
                            <em class="fas fa-chevron-right fa-lg" [ngClass]="{'fa-chevron-up': job.expanded}"></em>
                          </a>
                        </td>
                        <td>{{i+1}}</td>
                        <td><span translate>{{job.description}}</span></td>
                        <td>{{job.totalJobTimeSpent}} / {{job.totalTime}}</td>
                        <td>
                          <button [ngbTooltip]="job.demandStatus" [placement]="tooltipPlacement" tooltipClass="custom-revert" (click)="openUpdateJob(mymodal,job)"
                            *ngIf="job.demandStatus == 'Pending'" placement="bottom" aria-label="Center Align">
                            <img src="./../../../assets/images/ic_pending.png" height="32" width="32"
                              class="text-success" alt="" />
                          </button>
                          <button [ngbTooltip]="job.demandStatus" [placement]="tooltipPlacement" tooltipClass="custom-revert" (click)="openUpdateJob(mymodal,job)"
                          *ngIf="job.demandStatus == 'In Progress'" placement="bottom" aria-label="Center Align">
                            <img src="./../../../assets/images/ic_inProgress.png" height="32" width="32"
                              class="text-success" alt="" />
                          </button>
                          <button [ngbTooltip]="job.demandStatus" [placement]="tooltipPlacement" tooltipClass="custom-revert" (click)="openUpdateJob(mymodal,job)"
                          *ngIf="job.demandStatus == 'Completed'" placement="bottom" aria-label="Center Align">
                            <img src="./../../../assets/images/Complete.png" height="32" width="32"
                              class="text-success" alt="" />
                          </button>
                         </td>
                      </tr>
                      <ng-container *ngIf="job.expanded">
                        <tr class="table-active">

                          <td colspan="7" class="p-2 pl47">
                            <table class="tablest1 border">
                              <tr class="bg-light" *ngIf="job.jobTimeStamps.length>0;else load_else">
                                <th style="width:2%" scope="col">#</th>
                                <th style="width:8%" scope="col" translate>lblTimerType</th>
                                <th style="width:15%" scope="col" translate>lblMechanicName</th>
                                <th style="width:15%" scope="col" translate>lblStartTime</th>
                                <th style="width:15%" scope="col" translate>lblEndTime</th>
                                <th style="width:15%" scope="col" translate>lblDuration</th>
                                <th style="width:17%" scope="col" translate>lblReason</th>
                                <th scope="col" translate>lblUpdatedBy</th>
                                <th scope="col" translate>lblUpdatedDate</th>
                              </tr>
                              <tr *ngFor="let item of job.jobTimeStamps; let i=index" class="checkListItems">
                                <td>{{ i+1 }}</td>
                                <td>
                                  <div *ngIf="item.timerTypeId==3" translate>
                                    lblJobTimer</div>
                                <div *ngIf="item.timerTypeId==4" translate>
                                  lblJobDetailTimer</div>
                                </td>
                                <td>{{item.mechanicName}}</td>
                                <td> {{item.startTime | date:'shortDate' }}
                                  {{item.startTime | date:'HH:mm:ss' }}
                                </td>
                                <td> {{item.endTime | date:'shortDate' }}
                                  {{item.endTime | date:'HH:mm:ss' }}</td>
                                <td>
                                  <div *ngIf="item.duration == null">
                                    <span translate>-</span>
                                  </div>
                                  <div *ngIf="item.duration != null">
                                    {{item.duration}}
                                  </div>
                                </td>
                                <td>
                                  <div *ngIf="item.reason == null">
                                    <span translate>-</span>
                                  </div>
                                  <div *ngIf="item.reason != null">
                                    {{item.reason}}
                                  </div>
                                </td>
                                <td>{{item.updatedBy}}</td>
                                <td>{{item.updatedDate | date:'short'}}</td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <ng-template #load_else>
                    <tr>
                      <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                    </tr>
                  </ng-template>
                </tbody>
              </table>
            </div>
          </ng-template>
        </ngb-panel>
      </ngb-accordion>
    </ng-container>
    <ng-template #load_elsePart>
      <div class="no-record pad15" translate>lblNoRecordsFound</div>
    </ng-template>
  </div>
</div>

<ng-template #mymodal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title" translate>lblUpdateJobStatus</h4>
    <button type="button" #closeModal id="modelButton" class="close" aria-label="Center Align"
      (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-6">
        <div class="form-check">
          <input mdbRadio class="form-check-input" type="radio" name="JobRadioButton" value="1"
            [checked]="jobShowStatus == 'Pending'" (change)="ChangeJobStatusValue($event)">
          <label class="form-check-label" translate> lblPending </label>
        </div>
      </div>
      <div class="col-6">
        <div class="form-check">
          <input mdbRadio class="form-check-input" type="radio" name="JobRadioButton" value="2"
            [checked]="jobShowStatus == 'In Progress'" (change)="ChangeJobStatusValue($event)" />
          <label class="form-check-label" translate> lblInProgress </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <div class="form-check">
          <input mdbRadio class="form-check-input" type="radio" name="JobRadioButton" value="3"
            [checked]="jobShowStatus == 'Completed'" (change)="ChangeJobStatusValue($event)" />
          <label class="form-check-label" translate> lblCompleted </label>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <div class="d-flex flex-sm-row flex-column justify-content-end">
      <button type="submit" class="btn btn-primary mr-sm-2" translate (click)="serviceFunction()"
        [disabled]="updatedJobValue">lblUpdate</button>
      <button (click)="modal.dismiss('Cross click')" class="btn btn-secondary" aria-label="Center Align"
        translate>lblCancel</button>
    </div>
  </div>
</ng-template>